import * as React from 'react';
import type { ReactNode } from 'react';
import { useLocale, useTranslations } from '@accenturecodefoundry/mfe-pot-shared-i18n';
import { assetBaseUrl } from '../asset-base-url';
import './BenefitCardsSection.css';

export interface BenefitCardsSectionProps {
  headingKey: string;
  children: ReactNode;
}

/**
 * Section wrapper for a grid of `BenefitCard` components. Renders an h2 heading
 * and a responsive two-column card grid, mirroring the pattern used by
 * `ServiceLinksSection`. Self-serves locale/translations.
 */
export function BenefitCardsSection({ headingKey, children }: BenefitCardsSectionProps) {
  const locale = useLocale();
  const { t } = useTranslations(assetBaseUrl, locale);

  return (
    <section className="benefit-cards-section">
      <h2 className="benefit-cards-section__heading">{t(headingKey)}</h2>
      <div className="benefit-cards-section__grid">{children}</div>
    </section>
  );
}
